import { DressupClothing } from "GameObjects/StoryGame/ch1/DressupClothing";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Mix } from "Utils/Reflection";

export class DressupHolly extends HLF.Input.Receptacle {

    // protected receptacle = this.addChild();
    public z: number = 0;

    public clothing: {[key: string]: boolean} = {
        'skirt': false,
        'jacket': false,
        'boots': false,
        'necklace': false,
    };
    protected spine: PIXI.spine.Spine;

    constructor() {
        super();
        this.spine = this._visuals.addChild(HLF.PixiUtils.makeSpine("holly-front-rig"));
        this.playAnimation('pyjama-idle', true);
        this.spine.position.y = -80;
        // this.isActive = true;
        this.hitArea = new PIXI.RoundedRectangle(-200, -this.height - 10, 420, this.height, 100); // eyeballed
        // const g = this.addChild(new PIXI.Graphics());
        // g.beginFill(0xff0000, 0.5);
        // g.drawShape(this.hitArea as PIXI.RoundedRectangle);
        // g.endFill();
    }

    public onLayout() {
        // preserve aspect ratio
        this.scale.set(Math.max(this.scale.x, this.scale.y));
    }

    public update(pDeltaTime: number) {
        this.spine.update(pDeltaTime);
    }

    protected playAnimation(pName: string, pLoop: boolean = true) {
        if (this.spine.state.hasAnimation(pName + "-stepped")) {
            this.spine.state.setAnimation(0, pName + "-stepped", pLoop);
        }
        else if (this.spine.state.hasAnimation(pName)) {
            this.spine.state.setAnimation(0, pName, pLoop);
        }
        else {
            console.error(this.name + " no such animation: " + pName + " or " + pName + "-stepped");
        }
    }

    protected addDraggable(pDraggable: HLF.Input.Draggable) {
        super.addDraggable(pDraggable);

        if (pDraggable instanceof DressupClothing) {
            PubSub.publishSync('wear', pDraggable);

            const matchClothing = (pMatch: string, pSpineAnimationName: string, layer: number) => {
                if (pDraggable.name.indexOf(pMatch) > -1) {
                    this.spine.state.setAnimation(layer, pSpineAnimationName, false);
                    this.clothing[pMatch] = true;
                    PubSub.publishSync('wearing', this.clothing);
                }
            }

            matchClothing('skirt', 'closet-1-skirt-change-only', 1);
            matchClothing('jacket', 'closet-2-jacket-change-only', 2);
            matchClothing('necklace', 'closet-3-necklace-change-only', 3);
            matchClothing('boots', 'closet-4-boots-change-only', 4);
        }

        console.log(this.clothing);

    }

    protected onPointerMove(pEvent: PIXI.InteractionEvent): void {
        super.onTouchMove(pEvent); // sic
    }
}